import React from "react";

const SendIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.17463 8.16746L13.9592 13.8909L9.88767 20.4005C9.30414 21.3332 7.88744 21.1392 7.57893 20.0842L3.05277 4.62871C2.76963 3.66268 3.67283 2.76738 4.642 3.05436L20.0868 7.62685C21.1432 7.9401 21.332 9.34873 20.3953 9.92673L13.9602 13.8939"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SendIcon;
